module.exports = __webpack_public_path__ + "static/media/bookmark.712709b0.svg";